export default "__VITE_ASSET__Fcnz1kuE__"